<template>
  <div>
    <div class="container">
      <h4>DASHBOARD</h4>
      <!-- {{ number_format(now_d) }} -
      {{ number_format($store.state.auth.limit_timestamp) }} =
      {{
        number_format(
          parseInt(now_d) - parseInt($store.state.auth.limit_timestamp)
        )
      }}
      <hr />
      {{ $store.state.auth.token }}<br />
      {{ $store.state.auth }} -->
      <div v-if="false">
        <h5>リリース</h5>
        <ul>
          <li></li>
          <li></li>
        </ul>
      </div>

      <!-- {{ axiosHeader }} -->
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// import BsPageTitle from '../molecules/BsPageTitle.vue'
// // import BsButton from '../atoms/BsButton.vue'
// import BsSelect from '../atoms/BsSelect.vue'
// import BsDashBoardNav from './BsDashBoardNavView.vue'
// import BsPageNav from '../../molecules/BsPageNav.vue'
// import Common from '../../common/common'
// // import Checkin from './Checkin/CheckinView.vue'
// import axios from 'axios';
// import config from '../../const'

export default {
  name: 'BsDashBoardView',
  data: function () {
    return {
      tab_active: null,
      now_d: Date.now()
    }
  },
  props: {
    displayClass: {
      type: String,
      default: 'col-md-9 ms-sm-auto col-lg-10 px-md-4'
    }
  },
  components: {
    // BsPageTitle,
    // // BsButton,
    // BsSelect,
    // // Checkin,
    // BsDashBoardNav,
    // CheckinListView,
    // CheckoutListView,
    // DriveListView,
    // LodgeListView,
    // PaddockIndicatorView,
  },
  computed: {
    ...mapState({})
  },

  created() {},
  mounted: function () {
    // console.log(this.$route.path);
    // console.log('strage', this.$store.state.article, this.lists);
    // this.fromParentTitle = '商品詳細';
    console.log('mounted dash tab_active 1', this.tab_active)
    console.log(
      'mounted dash this.$route.query.tab 1',
      this.$route.query.target_tab
    )
    if (this.$route.query.target_tab) {
      this.tab_active = this.$route.query.target_tab
    }
    console.log('mounted dash tab_active 2', this.tab_active)
  },

  methods: {}
}
</script>
